/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Kits_Own_DescInputs */

const en_simple_kits_own_desc = /** @type {(inputs: Simple_Kits_Own_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few sentences in your own words. Bystep turns them into a plan.`)
};

const id_simple_kits_own_desc = /** @type {(inputs: Simple_Kits_Own_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tulis bebas beberapa kalimat. Bystep yang merapikan jadi rencana.`)
};

/**
* | output |
* | --- |
* | "A few sentences in your own words. Bystep turns them into a plan." |
*
* @param {Simple_Kits_Own_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_kits_own_desc = /** @type {((inputs?: Simple_Kits_Own_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Kits_Own_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_kits_own_desc(inputs)
	return en_simple_kits_own_desc(inputs)
});